import EntryExperience from "@/components/home/EntryExperience";
import { Navbar } from "@/components/layout/Navbar";
import { Hero } from "@/components/home/Hero";
// import { CohortStrip } from "@/components/home/CohortStrip";
import { CuratedNews } from "@/components/home/CuratedNews";
// import { AdBlock } from "@/components/shared/AdBlock";
import { FeaturedArticles } from "@/components/home/FeaturedArticles";
// import { RealFounderTalks } from "@/components/home/RealFounderTalks";
import { RFTComingSoon } from "@/components/home/RFTComingSoon";
import { Newsletter } from "@/components/home/Newsletter";
import { Footer } from "@/components/layout/Footer";

const HomePage = () => {
  return (
    <main
      data-testid="home-page"
      className="bg-[#050505] text-bone min-h-screen"
    >
      <EntryExperience />
      <Navbar />
      <Hero />
      {/* <CohortStrip /> */}
      <CuratedNews />
      {/* <AdBlock /> */}
      <FeaturedArticles />
      {/* <FounderBytes /> */}
      <RFTComingSoon />
      {/* <RealFounderTalks /> */}
      {/* <Events /> */}
      {/* <CohortEcosystem /> */}
      <Newsletter />
      <Footer />
    </main>
  );
};

export default HomePage;
